import repository from "../Repository";

export default {
  async getAllArea() {
    const res = await repository.get("all_area");
    return res;
  },

  // 国組織も合わせて取得する
  async getAllAreaWithNational() {
    // クエリを定義
    const query = JSON.stringify({ national_flg: "true" });
    const encodedQuery = encodeURI(query);
    const res = await repository.get(`/all_area?p=${encodedQuery}`);
    return res;
  }
};
